import { useEffect, useState } from "react";

/** Breakpoint alinhado ao `md` do Tailwind (768px). Abaixo disso = bottom sheet; acima = dropdown atual. */
export const MOBILE_FILTER_SHEET_MAX_PX = 767;

/**
 * Detecta viewport mobile para filtros (somente UI).
 * Desktop/PC permanece com o dropdown tradicional.
 */
export function useIsMobileFilterSheet(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(`(max-width: ${MOBILE_FILTER_SHEET_MAX_PX}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
}
